import { Monitor } from '../parts/tech'
import type { AssetContext, AssetDefinition } from '../types'

/** Display sizes, in metres of visible chassis width x height (16:9). */
const SIZES = {
  m24: { width: 0.545, height: 0.315 },
  m27: { width: 0.6, height: 0.345 },
} as const

/** Half the gap between the two screens of the dual setup. */
const DUAL_OFFSET = 0.29
/** Toe-in so the pair reads as a workstation and not two parallel slabs. */
const DUAL_TOE = 0.14

/**
 * Desktop monitor on a T-stand, sitting on whatever surface it is dropped on
 * (y = 0 is the tabletop plane, "front" — the screen face — looks at +Z).
 * The accent, when set, tints the display area.
 */
function MonitorDesk({ accent, variant = 'm24' }: AssetContext) {
  const dual = variant === 'doble'
  const size = variant === 'm27' ? SIZES.m27 : SIZES.m24

  if (dual) {
    return (
      <group>
        {[-1, 1].map((side) => (
          <group
            key={side}
            position={[side * DUAL_OFFSET, 0, 0]}
            rotation={[0, -side * DUAL_TOE, 0]}
          >
            <Monitor width={SIZES.m24.width} height={SIZES.m24.height} screenColor={accent} />
          </group>
        ))}
      </group>
    )
  }

  return <Monitor width={size.width} height={size.height} screenColor={accent} />
}

export const definition: AssetDefinition = {
  id: 'monitor-desk',
  name: 'Monitor',
  category: 'tech',
  // Declared at the width of a single screen; the dual variant overhangs it.
  footprint: [0.6, 0.2],
  height: 0.48,
  stackable: true,
  accentable: true,
  variants: [
    { id: 'm24', name: '24 pulgadas' },
    { id: 'm27', name: '27 pulgadas' },
    { id: 'doble', name: 'Doble' },
  ],
  keywords: ['monitor', 'pantalla', 'display', 'screen', 'ordenador', 'computer'],
  Component: MonitorDesk,
}
